module.exports = __webpack_public_path__ + "EvilIcons.140c53a7.ttf";